/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { NumberField, Picker, Item } from '@adobe/react-spectrum';
import ChevronLeft from '@spectrum-icons/workflow/ChevronLeft';
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';
import ChevronDoubleRight from '@spectrum-icons/workflow/ChevronDoubleRight';
import ChevronDoubleLeft from '@spectrum-icons/workflow/ChevronDoubleLeft';

import Style from './css/Pagination.module.scss';

export default function Pagination({ page, totalPageCount, size, sizeList,
  onPageSizeChange, onPageChange, paginationUIComponentArray: paginationUIComponentArrayProp,
  nextPageButtonText, previousPageButtonText, firstPageButtonText, lastPageButtonText
}: any): any {
  const onPageInput = (el: any) => {
    onPageChange(el);
  };

  const paginationUIComponentArray = paginationUIComponentArrayProp || [['pageSizeDropdown'], ['firstPageButton', 'previousPageButton', 'expandedPageNumberButtons',
    'nextPageButton', 'lastPageButton', 'goToSpecificPageField', ]
  ];

  const onPageInput1 = (el: any) => {
    if (el.code === 'Enter') {
      const value = Number(el.target.value);
      if (value > 0 && value <= totalPageCount && page !== value) {
        onPageChange(value);
      }
    }
  };

  const handleBackButtonClick = () => {
    onPageChange(page - 1);
  };

  const handleNextButtonClick = () => {
    onPageChange(page + 1);
  };

  const goToLastPage = () => {
    onPageChange(totalPageCount);
  }

  const goToFirstPage = () => {
    onPageChange(1);
  }

  const goToSpecificPage = (specificPage: number) => {
    onPageChange(specificPage);
  }

  const getPageButtonList = () => {
    const pageButtonList = [];
    let start = Math.floor(page / 10) * 10;
    start = (start + 5) < page ? (start + 6) : (start + 1);
    let end: number = start + 5;
    if (page % 10 === 0) {
      start = page - 4;
      end = page + 1;
    }
    for (let i = start; i < end; i += 1) {
      if (i <= totalPageCount) {
        pageButtonList.push(<button
          id={`expandedPageNumberButtons_${i}`}
          data-testid="prevBtn"
          type="button"
          tabIndex={0}
          className={`${[Style.IconeBase, Style.IconButton, Style.pageButton].join(' ')} ${i === page ? Style.highlightButton : ''}`}
          key={`expandedPageNumberButtons_${i}`}
          onClick={() => goToSpecificPage(i)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              goToSpecificPage(i);
            }
          }}
        >
          {i}
        </button>);
      }
    }
    return pageButtonList;
  }

  const components = {
    pageSizeDropdown: () =>
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>{sizeList?.length && <div className={Style.pickerWrap} data-testid="show" id="pageSize">
        Show:
        <Picker
          id="pageSizeDropdown"
          data-testid="paginationPicker"
          aria-label="pickerInput"
          UNSAFE_className={Style.picker}
          items={sizeList || {}}
          onSelectionChange={onPageSizeChange}
          defaultSelectedKey={size || 10}
          width="50px"
          menuWidth="size-1000"
        >
          {(item: any) => <Item data-testid={`item_${item.name}`}>{item.name}</Item>}
        </Picker>
      </div>
      }
      </>,
    firstPageButton: () =>
      <button
        id="firstPageButton"
        data-testid="previousFastBtn"
        type="button"
        tabIndex={0}
        className={[Style.IconeBase, Style.IconButton, Style.rightIcon].join(' ')}
        onClick={goToFirstPage}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            goToFirstPage();
          }
        }}
        disabled={page <= 1}
      >
        {firstPageButtonText || <ChevronDoubleLeft aria-label="go to first page" size="S" />}
      </button>
    ,
    previousPageButton: () => <button
      id="previousPageButton"
      data-testid="prevBtn"
      type="button"
      tabIndex={0}
      className={[Style.IconeBase, Style.IconButton].join(' ')}
      onClick={handleBackButtonClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleBackButtonClick();
        }
      }}
      disabled={page <= 1}
    >
      {previousPageButtonText || <ChevronLeft aria-label="ChevronLeft" size="S" />}
    </button>,

    expandedPageNumberButtons: getPageButtonList,

    goToSpecificPageField: () => <div id="goToSpecificPageField" className={Style.goToSpecificPageField}><NumberField
      data-testid="page"
      width="size-600"
      maxWidth="100%"
      value={page}
      hideStepper
      aria-label="text"
      onChange={(evt: any) => onPageInput(evt)}
      onKeyDown={(evt) => onPageInput1(evt)}
      minValue={1}
      maxValue={totalPageCount}
    />
      <span className={Style.paginationMargin}>
        of
        <span className={Style.paginationMargin} data-testid="totalPageCount">
          {totalPageCount}
        </span>
        pages
      </span></div>,
    nextPageButton: () => <button
      id="nextPageButton"
      data-testid="nextBtn"
      type="button"
      tabIndex={0}
      className={[Style.IconeBase, Style.IconButton, Style.rightIcon].join(' ')}
      onClick={handleNextButtonClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleNextButtonClick();
        }
      }}
      disabled={page > totalPageCount - 1}
    >
      {nextPageButtonText || <ChevronRight aria-label="ChevronRight" size="S" />}
    </button>,
    lastPageButton: () => <button
      id="lastPageButton"
      data-testid="nextFastBtn"
      type="button"
      tabIndex={0}
      className={[Style.IconeBase, Style.IconButton, Style.rightIcon].join(' ')}
      onClick={goToLastPage}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          goToLastPage();
        }
      }}
      disabled={page > totalPageCount - 1}
    >
      {lastPageButtonText || <ChevronDoubleRight aria-label="go to last page" size="S" />}
    </button>
  }

  const getContent = (divElementArray: string[]) => {
    const content: any[] = [];
    divElementArray.forEach(element => {
      content.push(<div key={element} id={element}>{components[element]()}</div>);
    });
    return content
  }

  return (
    <div className={[
      Style.paginationText,
      !(sizeList && sizeList.length) && Style.paginationEnd,
    ].join(' ')}
    >
      <div id="paginationLeftDiv" className={Style.paginationLeftDiv}>{getContent(paginationUIComponentArray[0])}</div>
      <div id="paginationRightDiv" className={Style.paginationRightDiv}>{getContent(paginationUIComponentArray[1])}</div>
    </div>)
}
